import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HouseboatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"houseboat"}/>
}
